import ExpandLessIcon from '@material-design-icons/svg/filled/expand_less.svg?react';
import ExpandMoreIcon from '@material-design-icons/svg/filled/expand_more.svg?react';
import { useState } from 'react';

interface SectionProps {
  title: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  collapsible?: boolean;
  defaultExpanded?: boolean;
}

export function Section({
  title,
  icon,
  actions,
  children,
  collapsible = false,
  defaultExpanded = true,
}: SectionProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className="rounded-lg border border-neutral-800/60 overflow-hidden">
      <div
        className={`px-4 py-2.5 border-b border-neutral-800/60 flex items-center justify-between gap-3 ${
          collapsible
            ? 'cursor-pointer hover:bg-neutral-800/20 transition-colors'
            : ''
        }`}
        onClick={
          collapsible ? () => setIsExpanded((value) => !value) : undefined
        }
      >
        <div className="flex items-center gap-2 min-w-0">
          {icon && (
            <span className="text-neutral-500 fill-current size-4 flex items-center justify-center shrink-0">
              {icon}
            </span>
          )}
          <h3 className="text-sm font-medium text-neutral-200 truncate">
            {title}
          </h3>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          {actions}
          {collapsible && (
            <button
              type="button"
              className="text-neutral-500 hover:text-neutral-300 fill-current transition-colors"
            >
              <span className="sr-only">
                {isExpanded ? 'Collapse section' : 'Expand section'}
              </span>
              {isExpanded ? (
                <ExpandLessIcon className="size-4 fill-current" />
              ) : (
                <ExpandMoreIcon className="size-4 fill-current" />
              )}
            </button>
          )}
        </div>
      </div>
      {(!collapsible || isExpanded) && <div className="p-4">{children}</div>}
    </div>
  );
}
